import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {StationModel} from "../models/station.model";

@Injectable({
  providedIn: 'root'
})
export class StationsService {
  constructor(
    private http: HttpClient
  ) {
  }

  getStations(): Observable<any> {
    return this.http.get<StationModel[]>(`${environment.apiURL}/station`).pipe(
      map(stations => stations.sort((a, b) => a.title.localeCompare(b.title))) // Sort by title A-Z
    );
  }

}
